import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getSession } from "@/infra/auth/AuthProvider";
import { AppProvider } from "@/components/shell/AppContext";
import { AppShell } from "@/components/shell/AppShell";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async () => {
    const s = await getSession();
    if (!s) throw redirect({ to: "/auth" });
    return { userId: s.userId };
  },
  component: () => (
    <AppProvider>
      <AppShell>
        <Outlet />
      </AppShell>
    </AppProvider>
  ),
});
